import { Baby } from 'lucide-react';
import type { ReactElement } from 'react';
import { Outlet } from 'react-router';

import { ToastProvider } from '../ui/Toast.js';
import { OfflineBanner } from './OfflineBanner.js';
import { PrimaryNav } from './PrimaryNav.js';
import styles from './AppShell.module.css';

/**
 * Application frame: skip link, brand header, primary navigation (bottom bar on small
 * screens, sidebar on large screens) and the routed page in `<main>`.
 */
export function AppShell(): ReactElement {
    return (
        <ToastProvider>
            <div className={styles.shell}>
                <a href="#content" className={styles.skipLink}>
                    Skip to content
                </a>

                <header className={styles.header}>
                    <div className={styles.brand}>
                        <span className={styles.brandMark} aria-hidden="true">
                            <Baby size={22} strokeWidth={2} />
                        </span>
                        <span className={styles.brandName}>Little Possum</span>
                    </div>
                </header>

                <div className={styles.navRegion}>
                    <PrimaryNav />
                </div>

                <main id="content" tabIndex={-1} className={styles.main}>
                    <OfflineBanner />
                    <Outlet />
                </main>
            </div>
        </ToastProvider>
    );
}
